import React, {useState} from "react";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";
import {InputNumber} from "primereact/inputnumber";
import {Calendar} from "primereact/calendar";
import {InputSwitch} from "primereact/inputswitch";
import GeneralUtils from "../../../../../utils/GeneralUtils";
import {toast} from "react-toastify";

const defaultExam = {
    title: '',
    description: '',
    objectIndex: 1,
    isPublished: false,
    durationMinutes: null,
    passPercent: null,
    startDate: null,
    endDate: null,
    questionPoolSize: 0,
    questionCount: 0,
}
const ExamForm = (props) => {
    const {index, cancel, save} = props;
    const [data, setData] = useState(!GeneralUtils.isNullOrEmpty(props.data) ? props.data : defaultExam);

    const handleSave = () => {
        if (GeneralUtils.isNullOrEmpty(data.title)) {
            return toast.warn('Lütfen tüm alanlarını doldurun.');
        }
        const pool = Number(data.questionPoolSize ?? 0);
        const count = Number(data.questionCount ?? 0);
        if (count < 0) {
            return toast.warn('Sınav soru sayısı negatif olamaz.');
        }
        if (count > pool) {
            return toast.warn('Sınav soru sayısı, havuz soru sayısından büyük olamaz.');
        }
        save(data);
    }


    const handleChange = (e) => {
        const value = e.target.value;
        setData({...data, [e.target.name]: value});
    }

    const toDate = (d) => (!d ? null : (d instanceof Date ? d : new Date(d)));

    return (
        <div className="flex flex-column gap-2">
            <div className="flex flex-column gap-2">
                <p style={{minWidth: "50px", fontWeight: "600"}}>Sınav {index + 1}</p>
                <InputText name="title" type="text" value={data.title} onChange={handleChange}
                           className="inputtext p-inputtext-sm" placeholder="Başlık Girin"/>
            </div>

            <div className="flex flex-column gap-2">
                <p style={{minWidth: "50px", fontWeight: "600"}}>Sınav Açıklaması</p>
                <InputTextarea name="description" value={data.description || ''} onChange={handleChange}
                               rows={3} autoResize className="inputtext p-inputtext-sm"
                               placeholder="Bir açıklama ekleyin."/>
            </div>

            {/* Make isPublished, durationMinutes, passPercent on the same line */}
            <div className="flex flex-row flex-nowrap gap-3 mt-2">
                <div className="flex-1 flex flex-column gap-2">
                    <p style={{minWidth: "50px", fontWeight: "600"}}>Süre (dakika)</p>
                    <InputNumber value={data.durationMinutes}
                                 onValueChange={(e) => setData({...data, durationMinutes: e.value})}
                                 min={0}
                                 placeholder="Örn: 60"
                                 inputClassName="p-inputtext-sm"
                                 className="w-full"/>
                </div>
                <div className="flex-1 flex flex-column gap-2">
                    <p style={{minWidth: "50px", fontWeight: "600"}}>Geçme Yüzdesi (%)</p>
                    <InputNumber value={data.passPercent}
                                 onValueChange={(e) => setData({...data, passPercent: e.value})}
                                 min={0} max={100}
                                 suffix="%"
                                 placeholder="Örn: 70%"
                                 inputClassName="p-inputtext-sm"
                                 className="w-full"/>
                </div>
            </div>

            {/* startDate and endDate should be on the same line */}
            <div className="flex flex-row flex-nowrap gap-3 mt-2">
                <div className="flex-1 flex flex-column gap-2">
                    <p style={{minWidth: "50px", fontWeight: "600"}}>Başlangıç Tarihi</p>
                    <Calendar locale="tr" value={toDate(data.startDate)}
                              onChange={(e) => setData({...data, startDate: e.value})}
                              dateFormat="dd.mm.yy"
                              placeholder="Tarih seçin"
                              showIcon className="w-full" inputClassName="p-inputtext-sm"/>
                </div>
                <div className="flex-1 flex flex-column gap-2">
                    <p style={{minWidth: "50px", fontWeight: "600"}}>Bitiş Tarihi</p>
                    <Calendar locale="tr" value={toDate(data.endDate)}
                              onChange={(e) => setData({...data, endDate: e.value})}
                              dateFormat="dd.mm.yy"
                              placeholder="Tarih seçin"
                              showIcon className="w-full" inputClassName="p-inputtext-sm"/>
                </div>
            </div>

            {/* Question pool size (disabled) and question count (editable) */}
            <div className="flex flex-row flex-nowrap gap-3 mt-2">
                <div className="flex-1 flex flex-column gap-2">
                    <p style={{minWidth: "50px", fontWeight: "600"}}>Havuz Soru Sayısı</p>
                    <InputNumber value={Number(data.questionPoolSize ?? 0)}
                                 inputClassName="p-inputtext-sm"
                                 className="w-full"
                                 disabled
                                 readOnly
                                 tooltip="Bu değer soru ekleme/silme ile otomatik güncellenir"/>
                </div>
                <div className="flex-1 flex flex-column gap-2">
                    <p style={{minWidth: "50px", fontWeight: "600"}}>Sınav Soru Sayısı</p>
                    <InputNumber value={Number(data.questionCount ?? 0)}
                                 onValueChange={(e) => {
                                     const pool = Number(data.questionPoolSize ?? 0);
                                     let v = typeof e.value === 'number' ? e.value : 0;
                                     if (v < 0) v = 0;
                                     if (pool > 0 && v > pool) v = pool;
                                     setData({...data, questionCount: v});
                                 }}
                                 min={0}
                                 max={Number(data.questionPoolSize ?? 0) || undefined}
                                 inputClassName="p-inputtext-sm"
                                 className="w-full"
                                 placeholder="Örn: 10"/>
                </div>
            </div>

            <div className="flex-1 flex flex-column gap-2">
                <p style={{minWidth: "50px", fontWeight: 600, margin: 0}}>Yayınla</p>
                <InputSwitch checked={!!data.isPublished}
                             onChange={(e) => setData({...data, isPublished: e.value})}/>
            </div>

            <div className="flex justify-content-end gap-2">
                <Button label="İptal" onClick={cancel} outlined size="small"/>
                <Button label="Kaydet" onClick={handleSave} raised size="small"/>
            </div>
        </div>
    )
};

export default ExamForm;
